/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TestTokenFactory,
  TestTokenFactoryInterface,
} from "../TestTokenFactory";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rate",
        type: "uint256",
      },
    ],
    name: "TokenCreated",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountToBurn",
        type: "uint256",
      },
    ],
    name: "burnToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tokenRate",
        type: "uint256",
      },
    ],
    name: "createToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "mintToken",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "tokenRates",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type TestTokenFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestTokenFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestTokenFactory__factory extends ContractFactory {
  constructor(...args: TestTokenFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestTokenFactory> {
    return super.deploy(overrides || {}) as Promise<TestTokenFactory>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TestTokenFactory {
    return super.attach(address) as TestTokenFactory;
  }
  connect(signer: Signer): TestTokenFactory__factory {
    return super.connect(signer) as TestTokenFactory__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestTokenFactoryInterface {
    return new utils.Interface(_abi) as TestTokenFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestTokenFactory {
    return new Contract(address, _abi, signerOrProvider) as TestTokenFactory;
  }
}
